module.exports = __webpack_public_path__ + "img/sld_scb_6_t1_dark.35c1b814.svg";